import React from "react";
import { Col, InputGroup, Row } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

const OrderItem = (props) => {
  const { i18n } = useTranslation();

  const formatTime = (isoString) => {
    const dt = DateTime.fromISO(isoString, { zone: "Europe/Warsaw" }).setLocale(i18n.language);
    return i18n.language === "en"
      ? dt.toLocaleString(DateTime.TIME_SIMPLE) // np. "3:45 PM"
      : dt.toLocaleString(DateTime.TIME_24_SIMPLE); // np. "15:45"
  };

  const inputValue = `${formatTime(props.departureTime)} - ${formatTime(props.arrivalTime)}`;

  const handleChange = () => {
    if (!props.disabled) {
      props.checkHandler(props.index);
    }
  };

  return (
    <Form>
      <Row>
        <Col className="gx-3 col-12">
          <InputGroup className="mb-3 justify-content-center">
            <InputGroup.Checkbox
              checked={props.checked}
              onChange={handleChange}
              aria-label="Checkbox for following text input"
              disabled={props.disabled}
            />
            <Form.Control
              type="text"
              value={inputValue}
              readOnly
              className="text-center"
              disabled={props.disabled}
            />
            <InputGroup.Text className="text-center">
              <span
                style={{
                  width: "calc(8ch + 1rem)",
                  opacity: props.disabled ? 0.5 : 1,
                }}
              >
                {props.price} {props.currency}
              </span>
            </InputGroup.Text>
          </InputGroup>
        </Col>
      </Row>
    </Form>
  );
};

export default OrderItem;
